import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-callback',
  templateUrl: './callback.component.html'
})
export class CallbackComponent implements OnInit {
  ngOnInit(): void {
    // Handle OIDC callback logic here if needed
  }
}
